// Central source for Activity Group mode constants
// String values kept for backward compatibility
export const ACTIVITY_GROUP_MODES = Object.freeze({
  REVIEW: 'review',
  INPUT: 'input',
})
